"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCarouselButton = exports.MobileTopDivider = exports.StyledDivider = exports.TwisterPlusLabelText = exports.TwisterPlusButtonText = exports.TwisterPlusLabelContainer = exports.TwisterVariationDetails = exports.TwisterPlusButtonContainer = exports.Container = exports.TwisterPlusButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const divider_1 = require("../../divider");
const themed_text_1 = require("../../themed-text");
const setBorderStyle = (props) => {
    const borderStyle = props.isValid ? 'solid' : 'dashed';
    const borderColor = props.selected ? '#007185' : '#888C8C';
    const borderSize = props.selected ? '3px' : '1px';
    return (0, styled_components_1.css) `
    border: ${borderSize} ${borderStyle} ${borderColor};
  `;
};
const setColor = (props) => {
    return (0, styled_components_1.css) `
    color: ${props.isValid ? props.theme.palettes.font.primary : '#CCC'};
  `;
};
exports.TwisterPlusButton = styled_components_1.default.button `
  flex-shrink: 0;
  padding: ${(props) => (props.selected ? '0px' : '2px 0px')};
  border-radius: 8px;
  background-color: ${(props) => (props.selected ? '#EDFDFF' : '#0F111108')};
  ${setBorderStyle};
  ${setColor};
  width: max-content;
  max-width: ${(props) => getTwisterButtonMaxWidth(props.deviceType)};
  min-width: ${(props) => (props.shallDisplayVariationDetails ? '138px' : '60px')};
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: column;
  &:hover {
    background-color: ${(props) => !props.isValid && !props.selected ? '#0F111108' : !props.selected ? '#F0F2F2' : '#EDFDFF'};
  }
`;
exports.Container = styled_components_1.default.div `
  margin-bottom: ${(props) => props.theme.spacings.small};
`;
exports.TwisterPlusButtonContainer = styled_components_1.default.div `
  display: flex;
  column-gap: 10px;
  flex-flow: nowrap;
  overflow-x: auto;
  width: 100%;
  row-gap: 5px;
  margin-bottom: 12px;
`;
exports.TwisterVariationDetails = styled_components_1.default.div `
  margin: 0px;
  padding: 8px;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #ffffff;
`;
exports.TwisterPlusLabelContainer = styled_components_1.default.div.attrs((props) => ({
    'aria-expanded': props.isOpen,
    role: 'button',
    tabIndex: 0
})) `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0px;
  width: 100%;

  & i {
    transition: 0.5s;
    margin-right: 10px;
    transform: ${(props) => props.isOpen && 'rotate(0.5turn)'};
  }

  & div {
    transition: 0.5s;
    display: flex;
    flex-direction: ${(props) => (props.isOpen ? 'row' : 'column')};
  }
`;
exports.TwisterPlusButtonText = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  font-size: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* set the maximum number of lines to display */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: ${(props) => props.shallDisplayVariationDetails && `${props.height}px`};
`;
exports.TwisterPlusLabelText = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  color: inherit;
`;
function getDividerMargin(deviceType) {
    switch (deviceType) {
        case monera_app_core_1.DeviceType.Mobile:
        case monera_app_core_1.DeviceType.MShop:
            return '0px -12px 0px -12px';
        case monera_app_core_1.DeviceType.Tablet:
        case monera_app_core_1.DeviceType.Desktop:
        default:
            return '0px -24px 0px -24px';
    }
}
function getTwisterButtonMaxWidth(deviceType) {
    switch (deviceType) {
        case monera_app_core_1.DeviceType.Mobile:
        case monera_app_core_1.DeviceType.MShop:
            return '150px';
        case monera_app_core_1.DeviceType.Tablet:
        case monera_app_core_1.DeviceType.Desktop:
        default:
            return '167px';
    }
}
exports.StyledDivider = (0, styled_components_1.default)(divider_1.Divider) `
  height: ${(props) => props.height};
  background-color: #e0e4e6;
  margin: ${(props) => getDividerMargin(props.deviceType)};
  flex-grow: 1;
`;
exports.MobileTopDivider = (0, styled_components_1.default)(divider_1.Divider) `
  width: auto;
  background-color: #e0e4e6;
  height: 0.5rem;
`;
exports.StyledCarouselButton = styled_components_1.default.button `
  height: 48px;
  width: 48px;
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: #ffffff;
  border: 1px solid #d5d9d9;
  padding: 0px 5px;
  box-shadow: 0px 2px 4px 0px #d5d9d980;
  border-radius: 8px;
  justify-content: center;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`;
